<app-expansion-panel [titre]="aptitude().nom" [item]="aptitude()" [actions]="canCheck() ? aptitudeManuelleActions : []">
  <div class="gap-md m-md grid">
    <app-expansion-panel titre="Interrelations">
      <div class="flex flex-col">
        @for (
          interrelation of getInterrelationsParPhase() | trierPar: 'nom';
          track interrelation.id;
          let last = $last
        ) {
          @if (canCheck()) {
            <app-checkbox-submenu-item [item]="interrelation.value" [formcontrol]="interrelations" />
          } @else {
            <div class="px-lg py-md flex items-center">
              {{ interrelation.nom }}
            </div>
          }

          @if (!last) {
            <div hlmItemSeparator></div>
          }
        } @empty {
          <span class="text-content-secondary paragraph-medium-medium py-md px-lg"
            >Pas d'interrelation associée à la phase de cette aptitude.</span
          >
        }
      </div>
    </app-expansion-panel>
    <app-expansion-panel titre="Productions">
      <div class="flex flex-col">
        @for (production of aptitude().productions; track production.id; let last = $last) {
          @if (canCheck()) {
            <app-checkbox-submenu-item [item]="production" [formcontrol]="productions">
              <button
                class="invisible group-hover/item:visible"
                (click)="redirectToRessourcesPro(production.id); $event.stopPropagation()"
                hlmBtn
                size="compact"
                variant="ghost"
                hlmTooltipTrigger="Voir les ressources professionnelles"
              >
                <ng-icon hlm size="sm" name="lucideEye" />
              </button>
            </app-checkbox-submenu-item>
          } @else {
            <div class="px-lg py-sm group/item flex items-center justify-between">
              <span>{{ production.nom }}</span>
              <button
                class="invisible group-hover/item:visible"
                (click)="redirectToRessourcesPro(production.id)"
                hlmBtn
                size="compact"
                variant="ghost"
                hlmTooltipTrigger="Voir les ressources professionnelles"
              >
                <ng-icon hlm size="sm" name="lucideEye" />
              </button>
            </div>
          }

          @if (!last) {
            <div hlmItemSeparator></div>
          }
        } @empty {
          <span class="py-md px-lg text-content-secondary paragraph-medium-medium"
            >Pas de production associée à cette aptitude.</span
          >
        }
      </div>
    </app-expansion-panel>
  </div>
</app-expansion-panel>
